export const DASH_BOARD = "/dashboard";
export const LANDING_PAGE = "/home";
export const CONFIG = "/config";
const routesService = {
	getLoginRoute: () => "/login",
	getRoleRoute: role => {
		return `${DASH_BOARD}/${role.toLowerCase()}`;
	},
	getRoleRoute_landing: role => {
		return `${LANDING_PAGE}/${role.toLowerCase()}`;
	},
	getTenantRoute: role => {
		return `${DASH_BOARD}/${role.toLowerCase()}/tenant/:tenantName`;
	}
};
export default routesService;
